import { apiUrl } from "./api";

/** Read an image file's pixel dimensions in the browser (best-effort). */
async function readImageSize(
  file: File,
): Promise<{ width: number; height: number } | null> {
  try {
    const bitmap = await createImageBitmap(file);
    const size = { width: bitmap.width, height: bitmap.height };
    bitmap.close();
    return size;
  } catch {
    return null;
  }
}

export interface UploadResult {
  r2Key: string;
  width?: number;
  height?: number;
}

/**
 * Upload a doha photo to the Worker's R2-backed /upload route. `token`
 * is the Clerk bearer (from useTokenGetter); omit it locally, where the
 * dev bypass authenticates by localhost.
 */
export async function uploadImage(
  file: File,
  token: string | null,
): Promise<UploadResult> {
  const dims = await readImageSize(file);
  const res = await fetch(apiUrl("/upload"), {
    method: "POST",
    headers: {
      "Content-Type": file.type,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: file,
  });
  if (!res.ok) {
    throw new Error(`Upload failed (${res.status})`);
  }
  const data = (await res.json()) as { r2Key: string };
  return { r2Key: data.r2Key, width: dims?.width, height: dims?.height };
}
